import serviceType from 'constants/serviceType';
import axiosClient from './aixosClient';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';

const luckySpinApi = {
    initLuckySpin(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'spinGame_init';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    getTimesSpin(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'spinGame_getSpinNum';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    excuteSpin(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'spinGame_doSpin';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    historyWinList(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'spinGame_getWiner';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    historySpin(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'spinGame_getHistory';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
};
export default luckySpinApi;
